import { usePage } from '@inertiajs/react';
import { m, AnimatePresence } from 'framer-motion';
import React from 'react';

interface PageTransitionProps {
    children: React.ReactNode;
}

export function PageTransition({ children }: PageTransitionProps) {
    const { url } = usePage();

    return (
        <AnimatePresence mode="wait" initial={false}>
            <m.div
                key={url.split('?')[0]}
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -8 }}
                transition={{
                    duration: 0.15,
                    ease: 'easeOut',
                }}
                className="w-full"
            >
                {children}
            </m.div>
        </AnimatePresence>
    );
}
